export const lg_header_about = {
  lg_header_about_th: {
    title: "เกี่ยวกับ Dmeets",
    details:
      "Dmeets คือแพลตฟอร์มห้องประชุมออนไลน์ที่พัฒนาโดยทีมงานในประเทศไทย ออกแบบมาเพื่อองค์กรที่ให้ความสำคัญกับการใช้งานง่ายและความปลอดภัย",
    details2:
      "เราเชื่อว่าการประชุมไม่ควรเป็นเพียงแค่การพูดคุย แต่ควรช่วยให้ทีมตัดสินใจได้อย่างชัดเจน มีบันทึกที่เชื่อถือได้ และจัดการข้อมูลอย่างส่วนบุคคลอย่างถูกต้อง",
    question1: "ประชุมง่าย เป็นมืออาชีพ",
    subquestion1:
      "Dmeets ช่วยให้คุณจัดการประชุมออนไลน์ได้อย่างราบรื่นและเป็นระบบ ไม่ว่าคุณจะบริหารธุรกิจ สอนออนไลน์ หรือประชุมทีม ทุกอย่างถูกออกแบบให้ใช้งานง่ายและชัดเจน",
    question2: "ออกแบบเพื่อประเทศไทย และสอดคล้องกับ PDPA",
    subquestion2:
      "Dmeets ถูกพัฒนาโดยคำนึงถึงพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล (PDPA)  ไฟล์บันทึกการประชุมและข้อมูลหลักของบริการถูกจัดเก็บอย่างปลอดภัยภายในประเทศไทย ภายใต้การดูแลของเรา เพื่อช่วยให้องค์กรควบคุมข้อมูลได้อย่างมั่นใจ",
    question3: "การบันทึกการประชุมอย่างเป็นทางการ",
    subquestion3:
      "การประชุมที่สำคัญควรมีเอกสารที่เป็นทางการ Dmeets มีบริการเสริมการจัดทำรายงานการประชุมโดยที่ปรึกษากฎหมายที่ได้รับใบอนุญาต เพื่อเปลี่ยนการสนทนาให้เป็นบันทึกที่เป็นระบบและเชื่อถือได้",
    question4: "ความปลอดภัย",
    subquestion4:
      "เราให้ความสำคัญกับความปลอดภัยของการสื่อสาร การแจ้งเตือนเมื่อมีการบันทึกอย่างชัดเจน และการจัดการข้อมูลอย่างโปร่งใส เพื่อให้คุณประชุมได้อย่างมั่นใจ",
    get_start: "เริ่มต้นใช้งาน",
    section2_title: "ติดต่อทีมงานของเรา",
    section2_details:
      "ไม่ว่าคุณกำลังมองหาข้อมูลเพิ่มเติม โซลูชันที่เหมาะสำหรับคุณ หรือต้องความช่วยเหลือเพิ่มเติม ทีมงานของเราพร้อมที่จะให้คำแนะนำ ติดต่อเราวันนี้",
    section2_btn: "ส่งข้อความ",
    badge: "เกี่ยวกับเรา",
    title: "เราคือ Dmeets",
    subtitle:
      "Dmeets คือแพลตฟอร์มประชุมออนไลน์ที่พัฒนาโดยคนไทย สร้างขึ้นสำหรับธุรกิจและองค์กรไทย เรามุ่งมั่นนำเสนอเทคโนโลยีการประชุมที่ปลอดภัย จัดเก็บข้อมูลในไทย และใช้งานง่าย",
    mission_title: "เป้าหมายของเรา",
    mission_p1:
      "เราต้องการสร้างแพลตฟอร์มประชุมออนไลน์ที่ปลอดภัยและเชื่อถือได้ เหมาะสำหรับคนไทย โดยเน้นความเป็นส่วนตัว การปฏิบัติตาม PDPA และจัดเก็บข้อมูลไว้ในประเทศ",
    mission_p2:
      "เราเชื่อว่าคนไทยควรมีสิทธิ์เข้าถึงเทคโนโลยีการประชุมออนไลน์ที่มีคุณภาพ โดยไม่ต้องกังวลถึงเรื่องความปลอดภัยของข้อมูลว่าจะไม่หลุดหรือถูกเก็บออกไปนอกประเทศไทย",
    values_title: "หลักการของเรา",
    values_subtitle: "หลักการที่ขับเคลื่อนทุกสิ่งที่เราทำ",
    value_security_title: "ความปลอดภัยมาก่อน",
    value_security_desc:
      "เราให้ความสำคัญกับความปลอดภัยของข้อมูลและความเป็นส่วนตัวของผู้ใช้เป็นอันดับแรก",
    value_user_title: "เน้นผู้ใช้เป็นศูนย์กลาง",
    value_user_desc: "สร้างขึ้นด้วยความเข้าใจเชิงลึกในความต้องการของธุรกิจไทย",
    value_innovation_title: "นวัตกรรม",
    value_innovation_desc:
      "พัฒนาอย่างต่อเนื่องเพื่อก้าวนำหน้าเทคโนโลยีและความต้องการของผู้ใช้",
    value_community_title: "ชุมชน",
    value_community_desc:
      "สร้างและสนับสนุนชุมชนผู้ใช้ของเราเพื่อการเติบโตที่ยั่งยืน",
    cta_title: "เริ่มใช้เลยวันนี้",
    cta_subtitle: "เริ่มใช้ Dmeets วันนี้และสัมผัสการประชุมออนไลน์ที่ดีกว่า",
    cta_start: "เริ่มฟรี",
    cta_contact: "ติดต่อเรา",
  },
  lg_header_about_en: {
    title: "About Dmeets",
    details:
      "Dmeets is a Thai-developed online meeting platform created for organizations that value simplicity,security, and accountability.",
    details2:
      "We believe meetings should not only connect people — they should help teams make cleardecisions, keep reliable records, and protect their information.",
    question1: "Simple & Professional Meetings",
    subquestion1:
      "Dmeets helps you run smooth and organized online meetings. Whether you’re managing a business, teaching a class, or leading a team discussion, everything is designed to be clear and easy to use.",
    question2: "Built for Thailand & PDPA",
    subquestion2:
      "Dmeets is designed with Thailand’s Personal Data Protection Act (PDPA) in mind. Meeting recordings and core service data are securely stored in Thailand under our management, helping organizations maintain better control of their information.",
    question3: "Official Meeting Minutes",
    subquestion3:
      "Important meetings deserve proper documentation. Dmeets offers optional official meeting minutes prepared by licensed legal advisors — turning discussions into structured and dependable records.",
    question4: "Built for Security and Trust",
    subquestion4:
      "We focus on secure communication, transparent recording notifications, and responsible data handling — so you can meet with confidence.",
    get_start: "Get Started",
    section2_title: "Get in Touch with Our Team",
    section2_details:
      "Whether you’re looking for more details, tailored solutions, or support, we’re here to assist. Tell us what you need, and we’ll help you find the right approach.",
    section2_btn: "Leave a Message",
    badge: "About Us",
    title: "We Are Dmeets",
    subtitle:
      "Dmeets is a Thai-developed online meeting platform built for Thai businesses and organizations. We are committed to delivering secure, reliable, and easy-to-use meeting technology designed around the needs of Thai users.",
    mission_title: "Our Mission",
    mission_p1:
      "We want to create a secure, reliable online meeting platform that is perfect for Thai organizations. Emphasizing privacy, PDPA compliance, and full Thai language support.",
    mission_p2:
      "We believe every organization should have access to high-quality online meeting technology without having to worry about data security or complicated tools.",
    values_title: "Our Values",
    values_subtitle: "Principles that drive everything we do",
    value_security_title: "Security First",
    value_security_desc:
      "We prioritize data security and user privacy above everything else.",
    value_user_title: "User-Centric",
    value_user_desc:
      "Built with deep understanding of Thai business needs and local requirements.",
    value_innovation_title: "Innovation",
    value_innovation_desc:
      "Continuously improving to stay ahead of technology and user needs.",
    value_community_title: "Community",
    value_community_desc:
      "Building and supporting our user community for sustainable growth together.",
    cta_title: "Join Us Today",
    cta_subtitle:
      "Start using Dmeets today and experience better online meetings",
    cta_start: "Start Free",
    cta_contact: "Contact Us",
  },
};
  